export default "__VITE_ASSET__4db480b6__"